/* Kosekroken cart extras: upsells, opt-in Fraktbeskyttelse, compare-at savings. */
(function () {
 if (window.kkCartExtras) return;
 window.kkCartExtras = true;
 var CFG = window.kkCartExtrasConfig || {};
 if (!CFG.protId) return;
 var PROT_ID = CFG.protId;
 var PROT_HANDLE = CFG.protHandle;
 var PROT_PRICE = CFG.protPrice;
 var MONEY_FORMAT = CFG.moneyFormat || '{{amount_with_comma_separator}} kr';
 var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
 var SHIELD = '<svg class="kkx-prot__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z"/><path d="M8.8 12.2l2.2 2.2 4.4-4.6"/></svg>';
 var recCache = {};
 var SHOW_UPSELL = false; // 30 Oct 2026: upsells removed from the cart (Sebastián); Fraktbeskyttelse stays.
 function money(cents) {
  var n = (cents / 100);
  var fmt = function (dec, thousands, decimal) {
   var parts = n.toFixed(dec).split('.');
   parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
   return parts.join(decimal);
  };
  return MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
   if (k === 'amount_with_space_separator') return fmt(2, ' ', ',');
   if (k === 'amount_no_decimals_with_space_separator') return fmt(0, ' ', ',');
   if (k === 'amount_with_comma_separator') return fmt(2, '.', ',');
   if (k === 'amount_no_decimals_with_comma_separator') return fmt(0, '.', ',');
   if (k === 'amount_no_decimals') return fmt(0, ',', '.');
   return fmt(2, ',', '.');
  });
 }
 function isCartPage() { return !!document.getElementById('main-cart-footer'); }
 function post(url, body) {
  return fetch(ROOT + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
 }
 function getCart() { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
 function refresh(retried) {
  if (isCartPage()) { window.location.reload(); return Promise.resolve(); }
  var drawer = document.querySelector('cart-drawer');
  return fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble').then(function (r) {
   if (!r.ok) throw new Error('sections ' + r.status);
   return r.json();
  }).catch(function (err) {
   // A failed redraw must not leave the drawer showing an old cart: retry once, then reload the page.
   if (!retried) return new Promise(function (res) { setTimeout(res, 700); }).then(function () { return refresh(true); }).then(function () { return null; });
   window.location.reload();
   return null;
  }).then(function (sections) {
   if (!sections) return;
   if (drawer && typeof drawer.renderContents === 'function') {
    drawer.renderContents({ id: null, sections: sections });
    var fresh = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
    if (fresh) drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
   }
   setTimeout(ensure, 50);
  });
 }
 function buildToggle() {
  var label = document.createElement('label');
  label.className = 'kkx-prot';
  label.setAttribute('data-kkx', 'prot');
  label.hidden = true;
  label.innerHTML = SHIELD + '<span class="kkx-prot__text"><span class="kkx-prot__head">Fraktbeskyttelse</span><span class="kkx-prot__sub"></span></span>' +
   '<span class="kkx-prot__right"><span class="kkx-prot__price"></span><input type="checkbox" class="kkx-switch" role="switch" data-kkx-prot aria-label="Legg til fraktbeskyttelse"></span>';
  label.querySelector('.kkx-prot__price').textContent = PROT_PRICE;
  label.querySelector('.kkx-prot__sub').textContent = 'Beskytt bestillingen mot tap og tyveri';
  return label;
 }
 function buildUpsell() {
  var box = document.createElement('div');
  box.className = 'kkx-up';
  box.setAttribute('data-kkx', 'up');
  box.hidden = true;
  box.innerHTML = '<p class="kkx-up__title">Passer godt med</p><div class="kkx-up__wrap">' +
   '<button type="button" class="kkx-up__nav" data-kkx-scroll="-1" aria-label="Forrige">&#8249;</button>' +
   '<div class="kkx-up__list" tabindex="0"></div>' +
   '<button type="button" class="kkx-up__nav" data-kkx-scroll="1" aria-label="Neste">&#8250;</button></div>';
  return box;
 }
 function inject() {
  var added = false;
  var drawer = document.getElementById('CartDrawer');
  if (drawer) {
   var dSub = drawer.querySelector('.drawer__footer .cart-drawer__footer') || drawer.querySelector('.drawer__footer .cart__ctas');
   if (dSub && !drawer.querySelector('[data-kkx="prot"]')) { dSub.parentNode.insertBefore(buildToggle(), dSub); added = true; }
   var dFoot = drawer.querySelector('.drawer__footer');
   if (SHOW_UPSELL && dFoot && !drawer.querySelector('[data-kkx="up"]')) { dFoot.insertBefore(buildUpsell(), dFoot.firstChild); added = true; }
  }
  var page = document.getElementById('main-cart-footer');
  if (page) {
   var pBlocks = page.querySelector('.cart__blocks');
   if (pBlocks && !page.querySelector('[data-kkx="prot"]')) { pBlocks.insertBefore(buildToggle(), pBlocks.firstChild); added = true; }
   if (SHOW_UPSELL && pBlocks && !page.querySelector('[data-kkx="up"]')) { pBlocks.insertBefore(buildUpsell(), pBlocks.firstChild); added = true; }
  }
  if (document.querySelector('#CartDrawer .cart-item:not([data-kkx-done]), #main-cart-items .cart-item:not([data-kkx-done]), #CartDrawer .totals:not([data-kkx-done]), #main-cart-footer .totals:not([data-kkx-done]), #cart-icon-bubble .cart-count-bubble:not([data-kkx-done])')) added = true;
  return added;
 }
 var productCache = {};
 function loadProduct(handle) {
  if (!productCache[handle]) {
   productCache[handle] = fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  return productCache[handle];
 }
 function renderSavings(cart) {
  var handles = {};
  cart.items.forEach(function (i) { handles[i.handle] = true; });
  return Promise.all(Object.keys(handles).map(loadProduct)).then(function (products) {
   var cmp = {};
   products.forEach(function (p) {
    if (!p) return;
    (p.variants || []).forEach(function (v) { cmp[v.id] = v.compare_at_price || 0; });
   });
   var regular = 0, paid = 0;
   cart.items.forEach(function (it, idx) {
    var c = cmp[it.variant_id] || 0;
    var unitCmp = Math.max(c, it.original_price);
    regular += unitCmp * it.quantity;
    paid += it.final_line_price;
    ['CartDrawer-Item-', 'CartItem-'].forEach(function (pre) {
     var row = document.getElementById(pre + (idx + 1));
     if (!row) return;
     row.setAttribute('data-kkx-done', '1');
     var old = row.querySelector('[data-kkx="line"]');
     if (old) old.remove();
     if (c > it.original_price) {
      var d = document.createElement('div');
      d.className = 'kkx-line';
      d.setAttribute('data-kkx', 'line');
      var s = document.createElement('s'); s.textContent = money(c);
      var sv = document.createElement('span'); sv.className = 'kkx-line__save';
      sv.textContent = 'Spar ' + money((c - it.original_price) * it.quantity);
      d.appendChild(s); d.appendChild(sv);
      var details = row.querySelector('.cart-item__details');
      if (details) details.appendChild(d);
     }
    });
   });
   var saved = regular - paid;
   document.querySelectorAll('#CartDrawer .totals, #main-cart-footer .totals').forEach(function (t) {
    t.setAttribute('data-kkx-done', '1');
    var old = t.parentNode.querySelector('[data-kkx="save"]');
    if (old) old.remove();
    if (saved > 0) {
     var row = document.createElement('div');
     row.className = 'kkx-save';
     row.setAttribute('data-kkx', 'save');
     var a = document.createElement('span'); a.textContent = 'Du sparer totalt';
     var b = document.createElement('span'); b.textContent = money(saved);
     row.appendChild(a); row.appendChild(b);
     t.parentNode.insertBefore(row, t);
    }
   });
  });
 }
 function loadRecs(items) {
  var key = items.map(function (i) { return i.product_id; }).join(',');
  if (recCache[key]) return Promise.resolve(recCache[key]);
  var inCart = {};
  items.forEach(function (i) { inCart[i.product_id] = true; });
  var picks = [];
  var jobs = [];
  var plan = items.slice(0, 3).map(function (it) { return [it, 'complementary']; });
  plan.push([items[0], 'related']);
  plan.forEach(function (step) {
   var it = step[0], intent = step[1];
   jobs.push(function () {
    if (picks.length >= 6 || (intent === 'related' && picks.length > 0)) return Promise.resolve();
    return fetch(ROOT + 'recommendations/products.json?product_id=' + it.product_id + '&limit=8&intent=' + intent)
     .then(function (r) { return r.ok ? r.json() : { products: [] }; })
     .then(function (j) {
      (j.products || []).forEach(function (p) {
       if (picks.length >= 6 || inCart[p.id] || p.handle === PROT_HANDLE || !p.available) return;
       if (picks.some(function (x) { return x.id === p.id; })) return;
       picks.push(p);
      });
     }).catch(function () {});
   });
  });
  return jobs.reduce(function (chain, job) { return chain.then(job); }, Promise.resolve())
   .then(function () { recCache[key] = picks; return picks; });
 }
 function setPrice(card, v) {
  var now = card.querySelector('.kkx-up__now'), was = card.querySelector('.kkx-up__was');
  now.textContent = money(v.price);
  was.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
  card.querySelector('[data-kkx-add]').setAttribute('data-kkx-add', v.id);
 }
 function renderRecs(box, recs) {
  var list = box.querySelector('.kkx-up__list');
  list.innerHTML = '';
  recs.forEach(function (p) {
   var avail = (p.variants || []).filter(function (x) { return x.available; });
   if (!avail.length) return;
   var url = p.url || (ROOT + 'products/' + p.handle);
   var card = document.createElement('div');
   card.className = 'kkx-up__item';
   var img = document.createElement('a');
   img.className = 'kkx-up__img'; img.href = url; img.tabIndex = -1;
   var first = avail[0];
   var pic = (first.featured_image && first.featured_image.src) || p.featured_image;
   if (pic) {
    var im = document.createElement('img');
    var src = pic.indexOf('//') === 0 ? 'https:' + pic : pic;
    im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    im.alt = ''; im.loading = 'lazy'; im.width = 80; im.height = 80;
    img.appendChild(im);
   }
   var info = document.createElement('div');
   info.className = 'kkx-up__info';
   var name = document.createElement('a');
   name.className = 'kkx-up__name'; name.href = url; name.textContent = p.title;
   var price = document.createElement('div');
   price.className = 'kkx-up__price';
   price.innerHTML = '<span class="kkx-up__now"></span><s class="kkx-up__was"></s>';
   info.appendChild(name); info.appendChild(price);
   if (avail.length > 1) {
    var sel = document.createElement('select');
    sel.className = 'kkx-up__select';
    sel.setAttribute('aria-label', 'Velg variant for ' + p.title);
    avail.forEach(function (v) {
     var o = document.createElement('option'); o.value = v.id; o.textContent = v.title; sel.appendChild(o);
    });
    sel.addEventListener('change', function () {
     var v = avail.filter(function (x) { return String(x.id) === sel.value; })[0];
     if (v) setPrice(card, v);
    });
    info.appendChild(sel);
   }
   var btn = document.createElement('button');
   btn.type = 'button'; btn.className = 'kkx-up__btn'; btn.textContent = 'Legg i handlekurv';
   btn.setAttribute('data-kkx-add', first.id);
   info.appendChild(btn);
   card.appendChild(img); card.appendChild(info);
   list.appendChild(card);
   setPrice(card, first);
  });
  box.hidden = list.children.length === 0;
  box.querySelectorAll('.kkx-up__nav').forEach(function (n) { n.hidden = list.children.length < 2; });
  autoplay(list);
 }
 function slide(list, dir) {
  var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
  if (dir > 0 && atEnd) list.scrollTo({ left: 0, behavior: 'smooth' });
  else if (dir < 0 && list.scrollLeft <= 4) list.scrollTo({ left: list.scrollWidth, behavior: 'smooth' });
  else list.scrollBy({ left: dir * list.clientWidth, behavior: 'smooth' });
 }
 var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 function autoplay(list) {
  if (reduce || list.children.length < 2 || list.dataset.auto) return;
  list.dataset.auto = '1';
  var pausedUntil = 0;
  var pause = function () { pausedUntil = Date.now() + 6000; };
  ['pointerdown', 'touchstart', 'wheel', 'focusin', 'mouseenter'].forEach(function (ev) { list.parentNode.addEventListener(ev, pause, { passive: true }); });
  var id = setInterval(function () {
   if (!list.isConnected) { clearInterval(id); return; }
   if (document.hidden || Date.now() < pausedUntil || !list.offsetParent) return;
   slide(list, 1);
  }, 3500);
 }
 var syncing = false;
 function sync() {
  if (syncing) return;
  syncing = true;
  getCart().then(function (cart) {
   var prot = cart.items.filter(function (i) { return i.variant_id === PROT_ID; })[0];
   var others = cart.items.filter(function (i) { return i.variant_id !== PROT_ID; });
   if (prot && (others.length === 0 || prot.quantity > 1)) {
    return post('cart/change.js', { id: prot.key, quantity: others.length ? 1 : 0 }).then(function () { syncing = false; return refresh(); });
   }
   renderSavings(cart);
   var qty = others.reduce(function (n, i) { return n + i.quantity; }, 0);
   document.querySelectorAll('#cart-icon-bubble .cart-count-bubble').forEach(function (b) {
    b.setAttribute('data-kkx-done', '1');
    var num = b.querySelector('[aria-hidden]');
    if (num) num.textContent = qty;
    b.style.display = qty ? '' : 'none';
   });
   document.querySelectorAll('[data-kkx="prot"]').forEach(function (el) {
    el.hidden = others.length === 0;
    el.querySelector('input').checked = !!prot;
    el.classList.remove('kkx-busy');
   });
   var boxes = document.querySelectorAll('[data-kkx="up"]');
   if (!boxes.length || !others.length) { boxes.forEach(function (b) { b.hidden = true; }); syncing = false; return; }
   return loadRecs(others).then(function (recs) {
    boxes.forEach(function (b) { renderRecs(b, recs); });
    syncing = false;
   });
  }).catch(function () { syncing = false; });
 }
 function ensure() { inject(); sync(); }
 document.addEventListener('change', function (e) {
  var cb = e.target.closest && e.target.closest('[data-kkx-prot]');
  if (!cb) return;
  var wrap = cb.closest('[data-kkx="prot"]');
  if (wrap) wrap.classList.add('kkx-busy');
  var req = cb.checked
   ? post('cart/add.js', { items: [{ id: PROT_ID, quantity: 1 }] })
   : post('cart/change.js', { id: String(PROT_ID), quantity: 0 });
  req.then(refresh, refresh);
 });
 document.addEventListener('click', function (e) {
  var nav = e.target.closest && e.target.closest('[data-kkx-scroll]');
  if (nav) {
   var list = nav.parentNode.querySelector('.kkx-up__list');
   if (list) slide(list, Number(nav.getAttribute('data-kkx-scroll')));
   return;
  }
  var btn = e.target.closest && e.target.closest('[data-kkx-add]');
  if (!btn) return;
  e.preventDefault();
  btn.disabled = true;
  btn.textContent = 'Legger til …';
  post('cart/add.js', { items: [{ id: Number(btn.getAttribute('data-kkx-add')), quantity: 1 }] }).then(refresh, refresh);
 });
 var timer;
 var observer = new MutationObserver(function (muts) {
  var relevant = muts.some(function (m) {
   return !(m.target.closest && m.target.closest('[data-kkx]'));
  });
  if (!relevant) return;
  clearTimeout(timer);
  timer = setTimeout(function () { if (inject()) sync(); }, 120);
 });
 function start() {
  ensure();
  observer.observe(document.body, { childList: true, subtree: true });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
   subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(ensure, 150); });
  }
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();